<div id="mySidenav" class="side-nav-scroll-container">
    <div class="side-nav-content">
      <div>
        <bs-side-navigation-menu></bs-side-navigation-menu>
      </div>
    </div>
</div>
<div class="main-content" id="main">
  <ng-content>
  </ng-content>
</div>
